import type React from 'react';

import { MembershipAwareness } from '../components/MembershipAwareness';
import { useMembershipAwarenessFormData } from '../formContext';
import { useMembershipExists } from '../shared/hooks/useMembershipExists';
import type { Props } from '../shared/types';

export const MembershipAwarenessContainer: React.FC<Props> = (props) => {
	const {
		data: {
			featureConfigs: { membershipEnabled },
		},
	} = useMembershipAwarenessFormData();
	const membershipExists = useMembershipExists();
	if (!membershipEnabled || membershipExists) return null;

	return <MembershipAwareness {...props} />;
};
